import { useIntl } from 'react-intl';
import { Severity } from '@tink/core/src/components/atoms/Icons/AlertIcon';
import { PageView } from '../../../models/analytics';
import { commonMessages } from '../../atoms/CommonMessages/messages';
import { messages as providerDisabledMessages } from '../ProviderTemporaryDisabled/messages';
import { VerboseErrorScreen } from '../VerboseErrorScreen/VerboseErrorScreen';
import { useUrlQuery } from '../../ApplicationProviders/UrlQueryProvider/UrlQueryProvider';

export type ProviderDownProps = {
  redirectHome: () => void;
  redirectBackToClient: () => void;
};

export const ProviderDown = ({ redirectBackToClient, redirectHome }: ProviderDownProps) => {
  const { providerName: isProviderPreselected } = useUrlQuery();
  const { formatMessage } = useIntl();

  return (
    <VerboseErrorScreen
      viewEvent={PageView.PROVIDER_HEALTH_STATUS_SCREEN}
      severity={Severity.INFO}
      title={formatMessage(providerDisabledMessages.unavailableMessage)}
      body={[{ text: formatMessage(providerDisabledMessages.tryAgain) }]}
      primaryAction={isProviderPreselected ? redirectBackToClient : redirectHome}
      primaryButtonText={
        isProviderPreselected
          ? formatMessage(commonMessages.ok)
          : formatMessage(providerDisabledMessages.selectAnother)
      }
      secondaryAction={isProviderPreselected ? undefined : redirectBackToClient}
      secondaryButtonText={isProviderPreselected ? undefined : formatMessage(commonMessages.cancel)}
    />
  );
};
